/**
 * NEXT_PUBLIC_PROJECT_ENV is used to set current environment because
 * Next.js doesn't support it
 * https://github.com/vercel/next.js/blob/master/errors/non-standard-node-env.md
 */
import URI from "urijs";

export enum ENV_ENUM {
  dev = "dev",
  production = "production",
  staging = "staging",
  uat = "uat",
}

export const environment = (process.env.NEXT_PUBLIC_PROJECT_ENV ||
  "") as string;
export const sentryEnvironment = (process.env.NEXT_PUBLIC_SENTRY_ENV ||
  "") as string;
export const isProductionReady = ["staging", "production", "uat"].includes(
  environment
);
export const isLocalEnv = !isProductionReady && !process.env.CI;
// FIXME: test env remove this please
export const isTestEnv = process.env.NODE_ENV == "test";

export const decovoShopAppId = "b0414f96-89ee-4a2d-94ea-9b062d2a7212";
export const sentryDSN = (process.env.NEXT_PUBLIC_SENTRY_DSN || "") as string;

export const apiSubdomain = process.env.NEXT_PUBLIC_API_SUBDOMAIN as
  | string
  | undefined;

export const endpoints = {
  cdn: process.env.NEXT_PUBLIC_CDN_URL as string,
  productsImgCdn: process.env.NEXT_PUBLIC_IMG_CDN_ROOT || ("" as string),
  web: process.env.NEXT_PUBLIC_WEB_ROOT as string,
  api: process.env.NEXT_PUBLIC_API_ROOT as string,
  corporateFrontend: process.env.NEXT_PUBLIC_CORPORATE_FRONTEND_ROOT as string,
  internalApi: process.env.NEXT_INTERNAL_API_ROOT as string,
};

export const cookies = {
  localStorageUserKey: "caps_user",
  cartCookieName: "decovo-shoppingcart",
  secureCookie: isProductionReady,
  defaultOptions: {
    path: "/",
    domain: URI(endpoints.web || window.location.host).domain(),
    secure: isProductionReady,
    maxAge: 7 * 24 * 60 * 60,
  },
};

export const cart = {
  maxCartQty: 15,
};

export const paypalClientId = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID;

export const sellerDetails = {
  name: "PepsiCo, Inc.",
  line1: "555 W Monroe St",
  cityStateZip: "Chicago, IL 60661",
};
